interface AuthorizationSettings {
  email: {
    isEnabled: boolean;
    value: boolean;
  };
  google2FA: {
    isEnabled?: boolean;
    value: boolean;
  };
}

interface SecuritySettingData {
  frontEndKey: string;
  title: string;
  settingType: string;
  settingValue: boolean | AuthorizationSettings;
}

interface GetSecuritySettingsResponse {
  data: SecuritySettingData[];
  msg: string;
}

enum SettingTypes {
  account = "account",
  general = "general",
}

export default SettingTypes;
export type {
  AuthorizationSettings,
  SecuritySettingData,
  GetSecuritySettingsResponse,
};
